export default "<div class=\"flux-editor-plus\">\n  <a href=\"#\" class=\"flux-editor-plus-button\"></a>\n</div>\n"